import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/Button';
import { EmptyState } from '@/components/ui/EmptyState';
import { useDocumentTitle } from '@/hooks/useDocumentTitle';

export function NotFound() {
  useDocumentTitle('Not found');
  return (
    <EmptyState
      title="We couldn't find that page."
      description="The link may be old, or the page may have moved."
      action={
        <Link to="/">
          <Button variant="secondary">Go home</Button>
        </Link>
      }
    />
  );
}
